import { getColor } from 'common/constants/_colors';
import styled from 'styled-components';

export const Row = styled.div``;
export const Field = styled.div``;

export const ServiceForm = styled.form`
  width: 100%;
  height: 100%;
  margin-top: 2rem;
  & ${Row} {
    display: flex;
    justify-content: space-between;
    color: ${getColor('shuttleGray')};
    margin-bottom: 1.5rem;
    width: 100%;
    /* border: 1px solid red;      */
    & ${Field} {
      & label {
        display: block;
        margin-bottom: 0.5rem;
        font-size: 1.2rem;
        font-weight: 500;
      }
      & input {
        display: block;
        width: 25rem;
        padding: 0.55rem;
      }
      & .input-description {
        margin-top: 0.5rem;
      }

      &.path {
        width: 100%;
        & main {
          display: flex;
          justify-content: space-between;
          & input {
            width: 90%;
          }
          & button {
            min-width: 5%;
          }
        }
      }
    }
  }
  & footer {
    position: absolute;
    bottom: 1rem;
    right: 1rem;
    & button {
      margin-right: 1rem;
    }
  }
`;
